import React from 'react';
import MediaCard from '@/pages/Onboarding/MediaCard';
import { useTranslations } from 'use-intl';
import { RegistryDocuments } from '@/graphql/__generated__/onboarding-legal';
import EmojiIcon from '@/stories/Components/EmojiIcon/EmojiIcon';

interface DocumentsSectionProps {
	documents: RegistryDocuments;
}

export const DocumentsSection: React.FC<DocumentsSectionProps> = ({ documents }) => {
	const t = useTranslations('RegistryDetails');

	return (
		<div className="flex flex-col p-6 gap-5 bg-slate-50 p-4 rounded-lg">
			<div className="flex flex-col gap-5">
				<div className="grid grid-cols-3 gap-5">
					<MediaCard
						translationKey="RegistryDetails"
						title={t('OrganizationalChartFileTitle')}
						files={[
							{
								url: documents.organizationalChart || '',
								label: 'organizationalChart'
							}
						]}
					/>
					<MediaCard
						translationKey="RegistryDetails"
						title={t('ShareholdersAndEquityHoldingsFileTitle')}
						files={[
							{
								url: documents.shareholdersAndEquityHoldings || '',
								label: 'shareholdersAndEquityHoldings'
							}
						]}
					/>
					<MediaCard
						translationKey="RegistryDetails"
						title={t('ShareholdingStructureFileTitle')}
						files={[
							{
								url: documents.shareholdingStructure || '',
								label: 'shareholdingStructure'
							}
						]}
					/>
				</div>
				<div className="grid grid-cols-2 gap-5">
					<MediaCard
						translationKey="RegistryDetails"
						title={'INE'}
						files={[
							{
								url: documents.legalRepresentativeIneFront || '',
								label: 'ineFront'
							},
							{
								url: documents.legalRepresentativeIneBack || '',
								label: 'ineBack'
							}
						]}
						icon={<EmojiIcon src="/id-emoji.svg" />}
					/>
					<MediaCard
						translationKey="RegistryDetails"
						title={'SELFIE'}
						files={[
							{
								url: documents.legalRepresentativeSelfie || '',
								label: 'selfie'
							}
						]}
						icon={<EmojiIcon src="/selfie-emoji.svg" />}
					/>
				</div>
			</div>
		</div>
	);
};

export default DocumentsSection;
